import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContentField } from '@xanadu/model';

@Component({
    selector: 'app-content-field',
    templateUrl: './content-field.component.html',
    styleUrls: ['./content-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentFieldComponent {
    formGroup = input<FormGroup>();
    field = input<ContentField>();
    node = input<Node>();
    readonly = input<boolean>(false);
}
